// 设置元素的 overflow 属性
const setElementOverflow = (value) => {
  if (document.documentElement && document.documentElement.style) {
    document.documentElement.style.overflow = value;
  }
  if (document.body && document.body.style) {
    document.body.style.overflow = value;
  }
};

export default {
  inserted(_, binding) {
    if (binding.value) {
      setElementOverflow('hidden');
    }
  },
  update(_, binding) {
    setElementOverflow(binding.value ? 'hidden' : '');
  },
  unbind() {
    setElementOverflow('');
  },
};
